import angular from 'angular';

import reportsDataService from 'app/services/data/reports.data.service';
import directive from './download-report.directive';
import controller from './download-report.directive.controller';

export default angular.module('app.components.global.downloadReport', [
  reportsDataService
])
  .directive('downloadReport', directive)
  .controller('DownloadReportDirectiveController', controller)
  .name;

console.log('app.components.global.downloadReport created');
